export function tabview(ctx) {
    return {
        properties: {
            btn_pos: 1,
            text_font: 32,
        },
        styles: {
            main: { ...ctx.pretty, radius: 0, border_width: 0 },
            // indicator = tabview_indic
            indicator: { bg_color: '#ffffff' },
            // items/tab-bg = tabview_btns_bg
            items: { bg_color: '#111111', border_color: '#ffffff', border_width: 1, radius: 0 },
        },
    };
}
